import React, { useEffect, useRef, useState } from 'react';
import { MenuForm } from '../Menu.js';
import { SecurityElement } from '../elements/security_element.js';
import { useAPICall } from '../../hooks/useAPICall.js';
import "../../css/main.css"
import { PageMenuElement } from '../elements/page_menu.js';
import { Navigate, useNavigate } from 'react-router-dom';

export function ViewMembershipForm() {
  
  const [memberData, setMemberData] = useState([]);
  const [competencyData, setCompetencyData] = useState([]);
  const [pageData, setPageData] = useState();
  const [membershipStatus, setMembershipStatus] = useState([]);
  const [imageData, setImageData] = useState();
  const [supplimentaryData, setSupplimentaryData] = useState([]);

  const navigate = useNavigate();
  let first_render = useRef(true);

  const { MakeCall } = useAPICall();



  useEffect(() => {

    if (first_render.current === true) {
      LoadMemberDataForView();
      first_render.current = false;
    }

  });

  function MemberStatus() {
    let status = membershipStatus.find((element) => memberData.idpeveril_status === element.id);
    if (status) {
      return status.description;
    }
    return 'NONE';

  }

  const handleMemberDataFetchForView = (data) => {
    setPageData(data);
    setMemberData(data.components['member']);
    setCompetencyData(data.components['competencytypes']);
    setMembershipStatus(data.components['membershipstatuses']);
    setSupplimentaryData(data.components["supplimentarydata"]);
    LoadMemberImage(data.components['member'].idpeveril_member);
  }

  function LoadMemberDataForView() {

    MakeCall('member/getviewmemberpage', "{ \"token\" : \"" + sessionStorage.getItem("Token") + "\"}", handleMemberDataFetchForView, false);
  }

  function ShowCompetencies() {
    let result = [];
    for (let i = 0; i < competencyData.length; i++) {
      const competency_item = competencyData[i];
      if (memberData.competencies.find((competency) => { if (competency.idpeveril_competency_type === competency_item.id) { return competency } return '' })) {
        result.push(<div className='formrow' key={competency_item.id} >
          <div className='formlabel'>{competency_item.description}</div>
          <div className='formvalue'>Y</div>
        </div>);
      }
      else {
        result.push(<div className='formrow' key={competency_item.id}>
          <div className='formlabel'>{competency_item.description}</div>
          <div className='formvalue'>N</div>
        </div>);
      }
    }
    return result;

  }
  function handleImageDataFetch(data) {
    setImageData(data.components['image_data']);
  }

  function LoadMemberImage(memberID) {
    const postBody = "{ \"token\" : \"" + sessionStorage.getItem("Token") + "\", " +
      "\"memberid\" : \"" + memberID + "\"}";

    MakeCall('admin/adminloadimage', postBody, handleImageDataFetch, true);
  }
  function ShowMemberImage() {
    let results = [];
    if (imageData) {
      results.push(<div><img alt='member' className='prcmemberimagesmall' src={'data:image/jpeg;base64,' + imageData} key="memberimg"></img></div>)
    }
    return results;
  }


  function ShowSupplimentaryData()
  {
    let result = [];
    if(supplimentaryData != null)
    {
    if (supplimentaryData.length > 0) {
     
      for (let i = 0; i < supplimentaryData.length; i++) {
  result.push(<div className='formrow' key={supplimentaryData[i].supplimentary_data_name} >
  <div className='formlabel'>{supplimentaryData[i].supplimentary_data_name}</div>
  <div className='formvalue'>{supplimentaryData[i].data_value}</div>
  </div>);
      }
      
    }
    }
  
    return result;
  }
  function handleNav(destination, state) {
    navigate(destination, state);
}

  function onPageMenuClick(onclickname) {
    switch (onclickname) {
        case 'goback':
            
            break;            
      case 'viewcard':
              handleNav("/ViewMembershipCard", { state: { memberID: memberData.idpeveril_member } });
              break;       
        case 'changepassword':
              document.getElementById('changepasswordform').style.display = "block"
              break;       
        default:
          break;
  
    }
  }

  function handleSavePassword(data)
  {
      document.getElementById("changepasswordform").style.display ="none";      

  }
  function handleChangePassword() {
    let currentpassword = document.getElementById('currentpassword').value;
    let newpassword = document.getElementById('newpassword').value;
    let confirmpassword = document.getElementById('confirmpassword').value;
    
     MakeCall('member/changepassword', "{ \"token\" : \"" + sessionStorage.getItem("Token") + "\"," +
             "\"currentpassword\":\"" + currentpassword + "\", "+
             "\"newpassword\":\"" + newpassword + "\", " +
             "\"confirmpassword\":\"" + confirmpassword + "\"}", handleSavePassword, true);
}

  function ChangePasswordForm() {
    
    return (
        <div className='popup_form' id="changepasswordform">
            <h1>Add a visit for this member</h1>                
            <div className='formrow' style={{"paddingBottom":"1em"}}>
                <div className='formlabel' style={{ "width": "30%" }}>
                    Current Password
                </div>
                <div className='formvalue'>
                  <input id='currentpassword' type="password" className='logininput'/>   
                </div>
            </div>
            <div className='formrow' style={{"paddingBottom":"1em"}}>
                <div className='formlabel' style={{ "width": "30%" }}>
                    New Password
                </div>
                <div className='formvalue'>
                  <input id='newpassword' type="password" className='logininput'/>   
                </div>
            </div>
            <div className='formrow' style={{"paddingBottom":"1em"}}>
                <div className='formlabel' style={{ "width": "30%" }}>
                    Confirm Password
                </div>
                <div className='formvalue'>
                  <input id='confirmpassword' type="password" className='logininput'/>   
                </div>
            </div>          
            <div className='formrowcentered'>
                <div className='formlabel'>
                    <input type='button' className='prcbtn' value='Change Password' onClick={handleChangePassword}/>
                </div>
                <div className='formlabel'>
                    <input type='button' className='prcbtn' value='Cancel' onClick={()=>{document.getElementById("changepasswordform").style.display ="none"}}/>
                </div>
            </div>
        </div>);    
}

  return (

    <div>

      {SecurityElement(pageData)}
      {MenuForm()}
      {ChangePasswordForm()}
      
      <div className="contentdiv">
      {PageMenuElement("Membership", [{ "name": "Back", "onclick": "goback" },
                { "name": "View Membership Card", "onclick": "viewcard" },
                { "name": "Change Password", "onclick": "changepassword" }], onPageMenuClick, false)}
        
          <div className='formbox'>
            <div className='formtitle'>Details</div>
            <div className='colspan'>
            <div style={{"width":"80%"}}>
              <div className='formrow'>
                <div className='formlabel' >Status</div>
                <div className='formvalue'>{MemberStatus()}</div>
              </div>
              <div className='formrow'>
                <div className='formlabel'>Number</div>
                <div className='formvalue'>{memberData.membership_number}</div>
              </div>
              <div className='formrow'>
                <div className='formlabel'>Type</div>
                <div className='formvalue'>{memberData.peveril_membership_type}</div>
              </div>
              <div className='formrow'>
                <div className='formlabel'>Forename</div>
                <div className='formvalue'>{memberData.forename}</div>
              </div>
              <div className='formrow'>
                <div className='formlabel'>Surname</div>
                <div className='formvalue'>{memberData.surname}</div>
              </div>
            </div>
            <div style={{"display": "flex", "width": "20%"}}>
              <div style={{"display": "flex","width": "100%", "alignContent": "right", "justifyContent":"end"}} >{ShowMemberImage()}</div>
            </div>
            </div>
          </div>
          <div className='formbox'>
            <div className='formtitle'>
              Contact Details
            </div>
            <div className='formrow'>
              <div className='formlabel'>Email</div>
              <div className='formvalue'>{memberData.email}</div>
            </div>
            <div className='formrow'>
              <div className='formlabel'>Mobile</div>
              <div className='formvalue'>{memberData.mobile_number}</div>
            </div>
            <div className='formrow'>
              <div className='formlabel'>Home</div>
              <div className='formvalue'>{memberData.fixed_line_number}</div>
            </div>
          </div>
          <div className='formbox'>
            <div className='formtitle'>
              Supplimentary Info
            </div>          
          {ShowSupplimentaryData()}
          </div>
          <div className='formbox'>
            <div className='formtitle'>
              Address
            </div>
            <div className='formrow'>
              <div className='formlabel'>House / Number</div>
              <div className='formvalue'>{memberData.house}</div>
            </div>
            <div className='formrow'>
              <div className='formlabel'>Street</div>
              <div className='formvalue'>{memberData.street}</div>
            </div>
            <div className='formrow'>
              <div className='formlabel'>Area</div>
              <div className='formvalue'>{memberData.area}</div>
            </div>
            <div className='formrow'>
              <div className='formlabel'>Town</div>
              <div className='formvalue'>{memberData.town}</div>
            </div>
            <div className='formrow'>
              <div className='formlabel'>Country</div>
              <div className='formvalue'>{memberData.country}</div>
            </div>
            <div className='formrow'>
              <div className='formlabel'>Postcode</div>
              <div className='formvalue'>{memberData.postcode}</div>
            </div>
          </div>
          <div className='formbox'>
            <div className='formtitle'>
              Competencies
            </div>
            {ShowCompetencies()}
          </div>

        </div>

      </div>
    


  );
}
